import { Fragment } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import MediaSizeTypes from 'ContentUtils/constants/MediaSizeTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.media.${key}`;
const SizingOptions = props => {
  const {
    customSizeOption,
    exactTooltip,
    fullWidthHelpText,
    fullWidthSizeOption,
    isExactSizingEnabled,
    isFullWidthSizingEnabled,
    maxSizeTooltip,
    onChange,
    originalSizeOption,
    sizeType,
    responsiveTooltip,
    showResponsiveSizingAlert,
    readOnly,
    useOnDark
  } = props;
  const onSizeTypeChange = e => {
    onChange(e);
  };
  const reponsiveSizeOptions = [{
    text: unescapedText(i18nKey('sizing.sizeType.options.responsive')),
    value: MediaSizeTypes.AUTO,
    help: responsiveTooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('sizing.sizeType.options.responsiveTooltip')
    })
  }, {
    text: unescapedText(i18nKey('sizing.sizeType.options.exact')),
    value: MediaSizeTypes.EXACT,
    help: exactTooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('sizing.sizeType.options.exactTooltip')
    })
  }];
  const maxSizingOptions = [{
    text: originalSizeOption || unescapedText(i18nKey('sizing.maxSizeType.options.original')),
    value: MediaSizeTypes.AUTO
  }, {
    text: customSizeOption || unescapedText(i18nKey('sizing.maxSizeType.options.custom')),
    value: MediaSizeTypes.AUTO_CUSTOM_MAX
  }];

  // The full width sizing option should be inserted between the other two
  if (isFullWidthSizingEnabled) {
    maxSizingOptions.splice(1, 0, {
      text: fullWidthSizeOption || unescapedText(i18nKey('sizing.maxSizeType.options.fullWidth')),
      value: MediaSizeTypes.AUTO_FULL_WIDTH,
      help: fullWidthHelpText || /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('sizing.maxSizeType.options.fullWidthTooltip')
      })
    });
  }
  const responsiveSizingAlert = /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    paddingBlock: "300",
    children: /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('sizing.sizeType.responsiveDisabled')
      }), /*#__PURE__*/_jsx(Button, {
        onClick: () => onSizeTypeChange(SyntheticEvent(MediaSizeTypes.EXACT)),
        size: "extra-small",
        use: "tertiary",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('sizing.sizeType.useExactButton')
        })
      })]
    })
  });
  const maxSizingSelect = /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('sizing.maxSizeType.label')
    }),
    tooltip: maxSizeTooltip,
    children: /*#__PURE__*/_jsx(Select, {
      buttonUse: useOnDark ? 'form-on-dark' : 'form',
      "data-test-id": "max-sizing-select",
      defaultValue: MediaSizeTypes.AUTO,
      onChange: onSizeTypeChange,
      options: maxSizingOptions,
      readOnly: readOnly,
      value: sizeType
    })
  });
  if (isExactSizingEnabled) {
    const responsiveSizingSelected = !!sizeType && sizeType !== MediaSizeTypes.EXACT;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [showResponsiveSizingAlert && responsiveSizingAlert, /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('sizing.sizeType.label')
        }),
        children: /*#__PURE__*/_jsx(Select, {
          buttonUse: useOnDark ? 'form-on-dark' : 'form',
          "data-test-id": "responsive-sizing-select",
          defaultValue: MediaSizeTypes.EXACT,
          onChange: onSizeTypeChange,
          options: reponsiveSizeOptions,
          readOnly: readOnly,
          value: responsiveSizingSelected ? MediaSizeTypes.AUTO : sizeType
        })
      }), responsiveSizingSelected && maxSizingSelect]
    });
  }
  return maxSizingSelect;
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
SizingOptions.defaultProps = {
  isFullWidthSizingEnabled: true
};
export default SizingOptions;